import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useScroll, useTransform } from 'framer-motion';

export default function WhatItIs() {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'center center'],
  });

  const opacity1 = useTransform(scrollYProgress, [0, 0.3], [0, 1]);
  const opacity2 = useTransform(scrollYProgress, [0.2, 0.5], [0, 1]);
  const opacity3 = useTransform(scrollYProgress, [0.4, 0.7], [0, 1]);
  const y1 = useTransform(scrollYProgress, [0, 0.3], [40, 0]);
  const y2 = useTransform(scrollYProgress, [0.2, 0.5], [40, 0]);
  const y3 = useTransform(scrollYProgress, [0.4, 0.7], [30, 0]);

  return (
    <section
      ref={ref}
      className="relative py-32 md:py-48 bg-[#faf9f5] dark:bg-[#141413] overflow-hidden"
    >
      {/* 背景光晕装饰 */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute left-[15%] top-1/3 h-80 w-80 -translate-y-1/2 rounded-full bg-[#ae5630]/6 blur-3xl" />
        <div className="absolute right-[10%] top-2/3 h-64 w-64 rounded-full bg-[#d97757]/5 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-4xl px-6 text-center">
        {/* line1 — 淡色前置文字，Fraunces 衬线 */}
        <motion.p
          style={{ opacity: opacity1, y: y1 }}
          className="font-display display-tight text-3xl font-medium leading-[1.1] text-[#87867f] dark:text-[#6b6a68] md:text-5xl lg:text-6xl"
        >
          {t('whatItIs.line1')}
        </motion.p>

        {/* line2 — 品牌色高亮，Fraunces */}
        <motion.p
          style={{ opacity: opacity2, y: y2 }}
          className="font-display display-tight mt-2 text-3xl font-medium leading-[1.1] text-[#ae5630] md:text-5xl lg:text-6xl"
        >
          {t('whatItIs.line2')}
        </motion.p>

        {/* 分割线装饰 */}
        <motion.div
          style={{ opacity: opacity2 }}
          className="mx-auto mt-10 h-px w-24 bg-gradient-to-r from-transparent via-[#ae5630]/40 to-transparent"
        />

        {/* description */}
        <motion.p
          style={{ opacity: opacity3, y: y3 }}
          className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-[#6b6a68] dark:text-[#9a9893] md:text-xl"
        >
          {t('whatItIs.description')}
        </motion.p>
      </div>
    </section>
  );
}
